module.exports = Promise.all([parcelRequire.load("3arc9"), parcelRequire.load("lVCxv")]).then(() => parcelRequire('dtzqx'));